import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams  } from '@angular/common/http';
import { Router } from '@angular/router';

import { JwtHelperService } from "@auth0/angular-jwt";


import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';


import { AuthService } from './auth.service';
import { BloquearPantallaService } from './bloquear-pantalla/bloquear-pantalla.service';

import { environment } from '../environments/environment';

@Injectable()

export class JwtRequestService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private bloquearPantallaService: BloquearPantallaService,
    private router: Router,
    private jwtHelper: JwtHelperService) {
    let token = localStorage.getItem('token');

    if (token == 'undefined') {
      this.authService.logout();
    }
  }

  get(url: string, id: any = null, params: any = null): Observable<any> {

    let data = this.request('get', url, id, params);
    if (id != null) {
      return data as Observable<any>;
    } else {
      return data as Observable<any[]>;
    }
  }

  post(url: string, params: any = null): Observable<any> {
    const data = this.request('post', url, null, params);

    return data as Observable<any>;
  }

  put(url: string, id: any = null, params: any = null): Observable<any> {
    const data = this.request('put', url, id, params);

    return data as Observable<any>;
  }

  delete(url: string, id: any = null, params: any = null): Observable<any> {
    const data = this.request('delete', url, id);

    return data as Observable<any>;
  }

  private request(method: string, url: string, id: any = null, params: any = {}): Observable<any> {

    let usuario = JSON.parse(localStorage.getItem('usuario'));
    let configuracion = JSON.parse(localStorage.getItem('configuracion'));
    let sucursal = localStorage.getItem('sucursal');
    let empresa = localStorage.getItem('empresa');
    let nivel_educativo = localStorage.getItem('nivel_educativo');
    let caja = localStorage.getItem('caja');

    let url_abs = '';
    let headersJson = {};
    if(!url){
      url = '';
    }
    if (url.indexOf('http') > -1) {
      let CFDI_PATH = environment.CFDI_PATH;
      if (url.indexOf(CFDI_PATH) > -1) {
        headersJson = {
          'Content-Type': 'application/json',
          'facturatelo': configuracion.sucursal.facturacion.facturatelo,
          'cambio': 1
        };
      } else {
        headersJson = {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        };
      }
      url_abs = `${url}`;
    } else {

      headersJson = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Disponible': environment.OAUTH_DISPONIBLE,
        'X-Usuario': usuario.email,
        'sucursal': sucursal,
        'empresa': empresa,
        'nivel-educativo': nivel_educativo,
        'caja': caja ? caja : '',

        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Cache-Control, Pragma, Origin, Authorization, Content-Type, X-Requested-With',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
        'Referrer-Policy': 'origin'
      };
      url_abs = `${environment.API_URL}/${url}`;
    }
    if (localStorage.getItem('token') == null) {
      return null;
    }

    let serverInfo = JSON.parse(localStorage.getItem('server_info'));
    let token = '';
    if (localStorage.getItem('token') == 'undefined') {
      this.bloquearPantallaService.bloquearPantalla();
    }

    token = this.jwtHelper.decodeToken(localStorage.getItem('token'));

    const data = new Observable(observer => {

      if (this.jwtHelper.isTokenExpired(localStorage.getItem('token'))) {
        
        let ttl: number = Number(serverInfo.token_refresh_ttl);
        ttl = Number.isNaN(ttl) ? 0 : ttl;

        let expiracionToken = this.jwtHelper.getTokenExpirationDate(localStorage.getItem('token'))
        let expiracionRefreshToken = new Date(expiracionToken.getTime() + (ttl * 60000));
        let clienteDate = new Date();

        if (expiracionRefreshToken.getTime() - clienteDate.getTime() <= 0) {
          this.bloquearPantallaService.bloquearPantalla(); // this.authService.logout(this.router.url);
        } else {
          // Refrescamos token
          this.authService.refreshToken().subscribe(
            () => {
              let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token'), 'Disponible': '0' });

              if (method == 'get') {
                let urlSearchParams = new URLSearchParams()
                if (params != null) {
                  for (let key in params) {
                    if (params.hasOwnProperty(key)) {
                      urlSearchParams.set(key, params[key]);
                    }

                  }
                }
                if (id == null) {
                  this.http.get(`${url_abs}`, { headers: headers, params: params })
                    .subscribe(
                    data => {
                      observer.next(data)
                    },
                    error => { observer.error(error) }
                    );
                } else {
                  this.http.get(`${url_abs}/${id}`, { headers: headers, params: params })
                    .subscribe(
                    data => {
                      observer.next(data)
                    },
                    error => { observer.error(error) }
                    );
                }
              }

              if (method == 'post') {
                this.http.post(`${url_abs}`, params, { headers: headers })
                  .subscribe(
                  data => {
                    observer.next(data)
                  },
                  error => { observer.error(error) }
                  );
              }

              if (method == 'put' && id != null) {
                this.http.put(`${url_abs}/${id}`, params, { headers: headers })
                  .subscribe(
                  data => {
                    observer.next(data)
                  },
                  error => { observer.error(error) }
                  );
              }

              if (method == 'delete' && id != null) {
                this.http.delete(`${url_abs}/${id}`, { headers: headers })
                  .subscribe(
                  data => {
                    observer.next(data)
                  },
                  error => { observer.error(error) }
                  );
              }

            }, error => {
              console.log('Token caducado. Se intento renolet pero el servidor no lo permitió, debido a que se superó el tiempo límite.');
              console.log('Bloqueando aplicación.');

              this.bloquearPantallaService.bloquearPantalla();
            }
          );
        }

      } else {
        
        if (method === 'get') {
          
          if (id == null) {
            this.http.get(`${url_abs}`, { headers: headersJson, params: params }).subscribe(
              response => {
                observer.next(response); this.hideLoader();
              },
              error => { 
                this.processError(error);
                observer.error(error); this.hideLoader();
              }
              );
          } else {
            this.http.get(`${url_abs}/${id}`, { headers: headersJson, params: params })
              .subscribe(
              response => {
                observer.next(response); this.hideLoader();
              },
              error => {
                this.processError(error);
                observer.error(error); this.hideLoader();
              }
            );
          }
        }

        let headers = new HttpHeaders(headersJson);

        if (method === 'post') {
          this.http.post(`${url_abs}`, params, { headers: headers })
            .subscribe(
            response => {
              observer.next(response); this.hideLoader();
            },
            error => {
              this.processError(error);
              observer.error(error); this.hideLoader();
            }
            );
        }

        if (method === 'put' && id != null) {
          this.http.put(`${url_abs}/${id}`, params, { headers: headers })
            .subscribe(
            response => {
              observer.next(response); this.hideLoader();
            },
            error => {
              this.processError(error);
              observer.error(error); this.hideLoader();
            }
            );
        }

        if (method === 'delete' && id != null) {
          this.http.delete(`${url_abs}/${id}`, { headers: headers })
            .subscribe(
            response => {
              observer.next(response); this.hideLoader();
            },
            error => {
              this.processError(error);
              observer.error(error); this.hideLoader();
            }
            );
        }
      }
    });
    return data;
  }

  processError(err) {
    let message = '';
    if(err.error instanceof ErrorEvent) {
     message = err.error.message;
    } else {
     message = `Error Code: ${err.status}\nMessage: ${err.message}`;
    }
    return throwError(message);
  }

  private onEnd(): void {

  }

  private showLoader(): void {
  }

  private hideLoader(): void {
  }
}
